import Link from 'next/link';
import type { LinkProps } from 'next/link';
import NextImage from 'next/image';
import { cn } from '@/lib/cn';

type LogoVariant = 'vertical' | 'horizontal';

interface LogoLinkProps extends Omit<LinkProps, 'href'> {
  href?: string;
  variant?: LogoVariant;
  width?: number;
  height?: number;
  className?: string;
  logoClassName?: string;
  ariaLabel?: string;
}

export function LogoLink({
  href = '/',
  variant = 'vertical',
  width,
  height,
  className,
  logoClassName,
  ariaLabel = 'Openigloo home',
  ...linkProps
}: LogoLinkProps) {
  // const Logo = variant === 'horizontal' ? LogoHorizontal : LogoVertical;
  const defaultSize =
    variant === 'horizontal' ? { width: 126, height: 28 } : { width: 60, height: 40 };

  return (
    <Link
      href={href}
      aria-label={ariaLabel}
      className={cn(
        'inline-flex shrink-0',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-2',
        className,
      )}
      {...linkProps}
    >
      <NextImage
        src={variant === 'horizontal' ? '/logo-horizontal.png' : '/logo-vertical.png'}
        alt={ariaLabel}
        priority={true}
        loading="eager"
        fetchPriority="high"
        // sizes={`${width ?? defaultSize.width}px`}
        height={height ?? defaultSize.height}
        width={width ?? defaultSize.width}
        className={logoClassName}
      />
    </Link>
  );
}
